import{jsx as e,jsxs as t}from"react/jsx-runtime";import{Component as o}from"react";import i,{css as n,keyframes as r}from"styled-components";import a from"react-focus-lock";import l from"./TooltipPortal.js";import s from"./TooltipDialogOverlay.js";import{calculateRem as d,withVDSManager as c}from"@vds-core/utilities";import{Fonts as p,Body as m}from"@vds-core/typography";import{ColorTokens as u}from"@vds-tokens/color";import{TypographyTokens as f}from"@vds-tokens/typography";import h from"./util/screen-reader.js";const g=i.div.withConfig({displayName:"Wrapper",componentId:"VDS__sc-7wisln-0"})`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 999;
`;function x(e){return"in"===e?r`
  0% {
    opacity: 0;
    transform: scale(1.2);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
`:r`
  0% {
    opacity: 1;
    transform: scale(1);
  }
  100% {
    opacity: 0;
    transform: scale(0.8);
  }
`}const y=i.div.withConfig({displayName:"Dialog",componentId:"VDS__sc-7wisln-1"})`
  padding-top: 16px;
  background-color: ${function({surface:e}){return"dark"===e?u.background.primary.dark.value:u.background.primary.light.value}};
  box-sizing: border-box;
  display: flex;
  flex-direction: column-reverse;
  flex-flow: column-reverse nowrap;
  justify-content: space-between;
  min-height: ${d(96)};
  max-height: ${d(312)};
  position: relative;
  width: ${d(296)};
  outline: none;
  z-index: 1000;
  border-radius: 12px;
  ${function({dialogOpened:e,disableAnimation:t}){return e&&!t&&n`
      animation: 0.2s cubic-bezier(0.37, 0, 0.63, 1) both 0s
        ${x("in")};
    `}};

  ${function({unmounted:e,disableAnimation:t}){return e&&!t&&n`
      animation: 0.1s cubic-bezier(0.37, 0, 0.63, 1) both 0s
        ${x("out")};
    `}};
`,v=i.span.withConfig({displayName:"StyledHeading",componentId:"VDS__sc-7wisln-2"})`
  display: flex;
  max-width: 100%;
  color: ${function({surface:e}){return"dark"===e?u.elements.primary.ondark.value:u.elements.primary.onlight.value}};
  font-family: ${p.VerizonNHGeDS};
  font-size: ${f.fontsize.title[20].value};
  line-height: ${f.lineheight.title[24].value};
  font-weight: ${f.fontweight.bold.value};
  padding-bottom: 8px;
  margin: 0;
`,w=i.span.withConfig({displayName:"StyledBody",componentId:"VDS__sc-7wisln-3"})`
  display: flex;
  width: 100%;
  color: ${function({surface:e}){return"dark"===e?u.elements.primary.ondark.value:u.elements.primary.onlight.value}};
  font-family: ${p.VerizonNHGeDS};
  font-size: ${f.fontsize.title[16].value};
  line-height: ${f.lineheight.title[20].value};
  letter-spacing: ${f.letterspacing.wide.value};
  padding-bottom: 16px;
`,b=i.div.withConfig({displayName:"DialogWrapper",componentId:"VDS__sc-7wisln-4"})`
  display: flex;
  overflow-y: scroll;
  padding: 0px 16px 0px 16px;
  border-bottom: ${d(1)} solid
    ${function({surface:e}){return"dark"===e?u.elements.lowcontrast.ondark.value:u.elements.lowcontrast.onlight.value}};
`,k=i.div.withConfig({displayName:"ContentContainer",componentId:"VDS__sc-7wisln-5"})`
  display: flex;
  width: 100%;
  flex-direction: column;
  max-height: calc(312px - 44px - 16px - 1px);
  word-break: break-word;
`,$=i.button.withConfig({displayName:"TooltipButton",componentId:"VDS__sc-7wisln-6"})`
  display: flex;
  width: 100%;
  height: ${d(44)};
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border: none;
  position: relative;
  outline: none;
`,D=i.span.withConfig({displayName:"ButtonTextContainer",componentId:"VDS__sc-7wisln-7"})`
  position: relative;
`;class C extends o{constructor(){super(...arguments),this.state={expandedStateText:"expanded! "}}componentDidMount(){var e=this;this.props.isAndroidDevice&&h.OpenDialog(),setTimeout((function(){e.setState({expandedStateText:""})}),500)}componentWillUnmount(){this.props.isAndroidDevice&&h.CloseDialog()}render(){const{title:o,body:i,onClick:n,surface:r,closeButtonText:d,dialogOpened:c,unmounted:p,dialogId:f}=this.props;return e(l,{children:e(g,{children:e(a,{disabled:!1,returnFocus:!0,children:e(s,{dialogOpened:c,opened:c,surface:r,viewport:"desktop",unmounted:p,children:t(y,{surface:r,dialogOpened:c,unmounted:p,id:f,role:"dialog","aria-modal":!0,children:[e($,{surface:r,onClick:n,"aria-label":`${this.state.expandedStateText}${d}`,children:e(D,{children:e(m,{size:"large",viewport:"mobile",color:"dark"===r?u.elements.primary.ondark.value:u.elements.primary.onlight.value,children:d})})}),e(b,{surface:r,children:t(k,{children:[!!o&&e(v,{surface:r,children:o}),e(w,{surface:r,children:i})]})})]})})})})})}}C.defaultProps={onClick:void 0,closeButtonText:"Close"};var S=c(C);export{S as default};
